"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.successAction = exports.requestAction = exports.failureAction = void 0;
var _types = require("./types");
var _actionGenerator = require("../../utils/actionGenerator");
const {
  GET_ADDRESS_GEO_SUGGEST_REQUEST: REQUEST,
  GET_ADDRESS_GEO_SUGGEST_SUCCESS: SUCCESS,
  GET_ADDRESS_GEO_SUGGEST_FAILURE: FAILURE
} = _types.EActionTypes;
const requestAction = exports.requestAction = (0, _actionGenerator.actionGenerator)(REQUEST);
const successAction = exports.successAction = (0, _actionGenerator.actionGenerator)(SUCCESS);
const failureAction = exports.failureAction = (0, _actionGenerator.actionGenerator)(FAILURE);